export default __webpack_public_path__ + "static/media/car.8b17b0bd.jpeg";